import { Component, OnInit, Injector, HostListener } from '@angular/core';
import { demoUsersModal } from '../demoUsers/demoUsers.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalGridModeService } from '../../../services/globalGridMode/globalGridMode.service';
import { GridOptions } from 'ag-grid';
import { liveUsersModal } from '../liveUsers/liveUsers.component';
import { currencyRenderer } from '../../../renderers/currencyFormatters.component';

@Component({
  selector: 'mobile-live-users-modal',
  template: require('./mobile-live-users-modal.component.html'),
  styles: [require('./mobile-live-users-modal.component.css')]
})
export class MobileLiveUsersModalComponent extends liveUsersModal {
  getRowHeight = () => 60;

  get horizontal()
  {
    return this.workspace.horizontalMode;
  }
  
  constructor(injector: Injector,
    public activeModal: NgbActiveModal,
    protected ngbModalService: NgbModal,
    protected globalGridModeService: GlobalGridModeService,
    ) 
    { 
      super(injector, activeModal, ngbModalService, globalGridModeService);


      
      this.setCellStyle(this.columnDefs[0]);
      (this.columnDefs[1] as any).hide = true;
      this.gridOptions.headerHeight = 40;


    }


  
    setCellStyle(columnDef: any)
    {
      columnDef.cellStyle = Object.assign(columnDef.cellStyle || {}, 
      {
        'font-size': '18px !important', 
        'line-height': this.getRowHeight() + 'px !important',
        'text-align': 'left'
      }) as any;
    }
    onGridReady(params: GridOptions) 
    {
      super.onGridReady(params);
      this.gridApi.sizeColumnsToFit();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) 
    {
      this.gridApi.sizeColumnsToFit();
    }

}
